module.exports = __webpack_public_path__ + "img/grn_ch_wurrzag_0.0171034b.png";